import React from "react";
import MainLayout from "../../components/layout/MainLayout";

// Terms content component
const TermsContent = () => {
  return (
    <div className="w-full bg-guru-floral-white">
      {/* Header banner with icon */}
      <div className="w-full bg-amber-50 py-6 px-8">
        <div className="flex items-center">
          <div className="mr-6 w-20 h-20 bg-amber-600 rounded-md flex items-center justify-center flex-shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-12 h-12">
              <path d="M19.903 8.586a.997.997 0 00-.196-.293l-6-6a.997.997 0 00-.293-.196c-.03-.014-.062-.022-.094-.033a.991.991 0 00-.259-.051C13.04 2.011 13.021 2 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-.021-.011-.04-.013-.062a.952.952 0 00-.051-.259c-.01-.032-.019-.063-.033-.093zM16.586 8H14V5.414L16.586 8zM6 20V4h6v5a1 1 0 001 1h5l.002 10H6z"></path>
              <path d="M8 12h8v2H8zm0 4h8v2H8zm0-8h2v2H8z"></path>
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-800">條款與細則</h1>
        </div>
      </div>

      {/* Content area */}
      <div className="w-full py-6 px-8">
        <div className="max-w-none text-gray-700">
          <p className="mb-4">歡迎您來到瓹窿瓹罅購物網站，為了維護您的權益，請詳閱本商店之約定條款。</p>

          <p className="mb-4">
            當您於結帳購物車時點選我同意服務條款和退換貨政策，即表示您已知悉並同意此約定條款之全部內容。本店將依照個人資料保護法令相關規定保護您的個人資料，並遵守商店隱私權保護政策。
          </p>

          <p className="mb-6">當您使用本店於之服務時，即表示您同意以電子文件作為意思表示之方法。</p>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">- 登記會員相關 -</h2>
            <ol className="list-decimal pl-8 space-y-2">
              <li>顧客可用電郵作為登記會員之方法。</li>
              <li>
                登記時顧客必須：
                <ol className="list-none pl-4 pt-2 space-y-2">
                  <li className="flex">
                    <span className="mr-2">a.</span>
                    <span>提供準確、完整及最新的登記資料；</span>
                  </li>
                  <li className="flex">
                    <span className="mr-2">b.</span>
                    <span>確保妥善保存個人使用者名稱及密碼；</span>
                  </li>
                  <li className="flex">
                    <span className="mr-2">c.</span>
                    <span>切勿透露任何帳戶資料及密碼給第三者</span>
                  </li>
                </ol>
              </li>
              <li>如顧客所登記的資料有任何更改，須立即通知我們以確保我們能夠有效地聯絡你。</li>
              <li>
                新會員優惠必須為從未使用相同電郵、電話號碼或上門送貨地址進行登記。如發現使用相同電郵、電話號碼或上門送貨地址進行重覆登記，是次新會員優惠將會被即時取消及所有已訂購之貨品須收回原價。瓹窿瓹罅亦有合理懷疑顧客所登記的資料屬不實、不準確或不完整，我們有權註銷顧客的會員資格，保留權利取消訂單，並恕不另行通知。
              </li>
              <li>在第4點情況下，顧客在此同意不向我們提出訴訟及索償或追討任何賠償。</li>
            </ol>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">- 私隱相關 -</h2>

            <h3 className="font-medium mb-2">私隱條款</h3>
            <p className="mb-4">
              雅逸貿易有限公司 (以下簡稱為「GuruGuruHK.com」) 尊重任何瀏覽本網頁 (www.guruguruhk.com)
              的人士或登記使用瓹窿瓹罅GuruGuruHK的服務的人士的私隱權。
              我們會確保所收集、傳送、儲存及使用的個人資料將遵照香港特別行政區法例第486章的規定處理。使用本網站即視為你同意接受本私隱政策的相關規定。如果你不同意本私隱政策部分或全部條款，我們可能無法為你提供服務。如果你提供個人資料，即代表你同意我們按本私隱政策聲明使用你的個人資料。
            </p>

            <h3 className="font-medium mb-2">適用範圍</h3>
            <p className="mb-4">
              瓹窿瓹罅GuruGuruHK 隱私權聲明及其所包含之告知事項，僅適用於 瓹窿瓹罅GuruGuruHK所擁有及經營的網站。
            </p>

            <h3 className="font-medium mb-2">個人資料蒐集之目的與類別</h3>
            <p className="mb-4">
              瓹窿瓹罅GuruGuruHK為了提供電子商務服務、售後服務、履行法定或合約義務、保護當事人及相關利害關係人之權益、行銷、客戶管理與服務、以及經營合於營業登記項目或組織章程所定之業務等目的，依照各服務之性質，有可能會蒐集您的姓名、性別、出生日期、連絡方式
              (包括但不限於電話、E-MAIL及地址等)、為完成收款或付款所需之資料（例如信用卡詳情)、ＩＰ位址、及其他得以直接或間接識別使用者身分之個人資料。
            </p>
            <p className="mb-4">
              此外，為提升服務品質， 瓹窿瓹罅GuruGuruHK 會依照所提供服務之性質，記錄使用者的IP位址、以及在 LOHAS-MALL
              相關網站的瀏覽活動( 包括但不限於使用者所使用的軟硬體、所點選的網頁、下載的APP)
              等資料，而且這些資料僅供作流量分析和網路行為調查，以便於改善 瓹窿瓹罅GuruGuruHK 的服務品質，不會和特定個人相連繫。
            </p>

            <h3 className="font-medium mb-2">個人資料的利用</h3>
            <p className="mb-4">
              瓹窿瓹罅GuruGuruHK 所蒐集的足以識別使用者身分的個人資料、消費與交易資料，或日後經您同意而提供之其他個人資料，都僅供
              瓹窿瓹罅GuruGuruHK 於其內部、依照蒐集之目的進行處理和利用、或為完成提供服務或履行合約義務之必要，否則
              瓹窿瓹罅GuruGuruHK
              不會將足以識別使用者身分的個人資料提供給本隱私權條款未逐一陳列的第三人（包括境內及境外）、或移作蒐集目的以外之使用。
            </p>
            <p className="mb-4">
              瓹窿瓹罅GuruGuruHK
              會持續保管、處理及利用相關資料。在以上蒐集目的範圍內，本商店會將所蒐集的個人資料，提供予合作廠商（包括但不限提供本服務之SHOPLINE、宅配貨運業者或其他）以協助交易完成或終止。若選擇以信用卡方式支付，僅限信用卡持卡人本人使用，且得就此交易資料向發卡銀行、收單行及持卡人照會並確認是否屬實，於核對無誤後付款程序才算完成。依上開蒐集目的所取得的個人資料，可能會傳送至您的國家或地區以外的地方進行保存或處理，且於符合個人資料保護法的情況下才會將您的資訊傳送至境外。
            </p>

            <h3 className="font-medium mb-2">資料安全</h3>
            <p className="mb-4">瓹窿瓹罅GuruGuruHK 將以合於產業標準之合理技術及程序，維護 瓹窿瓹罅GuruGuruHK 個人資料之安全。</p>

            <h3 className="font-medium mb-2">資料當事人之權利</h3>
            <p className="mb-4">
              資料當事人可以請求查詢、閱覽本人的個人資料或要求給予複本。若您的個人資料有變更、或發現您的個人資料不正確，可以向
              瓹窿瓹罅GuruGuruHK
              要求修改或更正；如您所提供之資料錯誤或缺漏，則不受本隱私權聲明之保護。當蒐集個人資料之目的消失或期限屆滿時，您可要求刪除、停止處理或利用個人資料。
            </p>

            <h3 className="font-medium mb-2">Cookie</h3>
            <p className="mb-4">
              為了便利使用者， 瓹窿瓹罅GuruGuruHK
              網站可能會讀取儲存在使用者電腦中的cookie資料。使用者可以經由瀏覽器的設定，取消、或限制此項功能，但可能因此無法使用部份網站功能。若您想知道如何取消、或限制此項功能，請與
              瓹窿瓹罅GuruGuruHK 客服中心聯絡。
            </p>

            <h3 className="font-medium mb-2">修訂之權利</h3>
            <p className="mb-4">
              本私隱政策是網站使用條款及細則的組成部分，將視為你與本公司之間協議的一部分。瓹窿瓹罅GuruGuruHK
              有權隨時修訂本隱私權聲明及相關告知事項，並得於修訂後公佈在網站，不另行個別通知，您可以隨時在 瓹窿瓹罅GuruGuruHK
              網站上詳閱修訂後的隱私權聲明及相關告知事項。
            </p>

            <h3 className="font-medium mb-2">個人資料之查閱及更正</h3>
            <p className="mb-4">
              如果你有任何疑問或意見，或有意查閱或更正個人資料，歡迎WhatsApp / Signal +852
              57448696或電郵cs@guruguruhk.com聯絡我們。
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4">- 訂單相關 -</h2>
            <ol className="list-decimal pl-8 space-y-2">
              <li>
                本店保留訂單接受與否之權利，若因意外等狀況導致無法接受您的訂單，將使用WhatsApp、Signal、電話、MAIL或站內訂單留言與您聯繫，可更換訂單內容或辦理退款，如造成您的不便，敬請見諒。(所有退款會以Guru
                Dollar退回)
              </li>
              <li>
                訂購多樣商品，請於同一購物車結帳(義賣及唔准嘥嘢專區需分單)，若分開結帳產生二筆以上之訂單，請依各別的專用付款方式/帳號完成付款，恕系統無法合併付款與合併訂單出貨，請務必留意。
              </li>
              <li>本店所有價格均以港幣計算</li>
            </ol>
          </div>

          <div className="mt-10 pt-6 border-t border-gray-200 text-center text-sm text-gray-500">
            <p>最後更新日期：2025年3月11日</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main component (simplified to take full width)
const Main = () => {
  return (
    <div className="w-full bg-white">
      <TermsContent />
    </div>
  );
};

// Page component
export default function TermsPage() {
  return (
    <MainLayout title="條款與細則 | GuruGuruHK" url="/article/terms">
      <Main />
    </MainLayout>
  );
}
